export enum CommodityStatuses {
  true = 'Active',
  false = 'Archived',
}

export default CommodityStatuses;
